import { Component } from '@angular/core';
import { MachinePerformanceListComponent } from "./components/machine-performance-list/machine-performance-list.component";

@Component({
  selector: 'app-machine-performances-view',
  imports: [MachinePerformanceListComponent],
  templateUrl: './machine-performances-view.component.html',
  styleUrl: './machine-performances-view.component.scss'
})
export class MachinePerformancesViewComponent {

}
